export const DISRUPTED_CONNECTION_TOOLTIP =
	'This connection has been interrupted and requires re-authentication before ingestion jobs can resume.';

// check if a connection is disrupted (expired or failed)
export const isConnectionDisrupted = (connection) => {
	if (!connection) return false;
	const status = connection.connection_status;
	return status === 'expired' || status === 'failed';
};

// determine button state based on connection status
export const getConnectionButtonState = (
	connection,
	providerName,
	isAuthLoading = false
) => {
	const defaultColor =
		providerName?.toLowerCase() === 'gmail' ? 'indigo' : 'primary';

	if (!connection || connection.connection_status === 'disconnected') {
		return {
			label: `Connect ${providerName}`,
			disabled: false,
			loading: Boolean(isAuthLoading),
			tooltip: null,
			color: defaultColor,
			isDisrupted: false,
		};
	}

	switch (connection.connection_status) {
		case 'connected':
			return {
				label: `${providerName} Connected`,
				disabled: true,
				loading: false,
				tooltip: null,
				color: defaultColor,
				isDisrupted: false,
			};
		case 'connecting':
		case 'refreshing':
			return {
				label: 'Connecting...',
				disabled: true,
				loading: true,
				tooltip: null,
				color: defaultColor,
				isDisrupted: false,
			};
		case 'expired':
			return {
				label: `Re-Connect ${providerName}`,
				disabled: false,
				loading: Boolean(isAuthLoading),
				tooltip: DISRUPTED_CONNECTION_TOOLTIP,
				color: 'warning',
				isDisrupted: true,
			};
		case 'failed':
			return {
				label: `Re-Connect ${providerName}`,
				disabled: false,
				loading: Boolean(isAuthLoading),
				tooltip: DISRUPTED_CONNECTION_TOOLTIP,
				color: 'error',
				isDisrupted: true,
			};
		default:
			return {
				label: `Connect ${providerName}`,
				disabled: false,
				loading: Boolean(isAuthLoading),
				tooltip: null,
				color: defaultColor,
				isDisrupted: false,
			};
	}
};
